module.exports = __webpack_public_path__ + "img/story034.6d5f154f.webp";